/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';

export class EmailListVO extends JSONable {
  uuid: string | undefined = undefined;
  messageID: string | undefined = undefined;
  receiveDate: Date | undefined = undefined;
  subject: string | undefined = undefined;
  from: string | undefined = undefined;
  to: string | undefined = undefined;
  cc: string | undefined = undefined;
  plainTextContent: string | undefined = undefined;
  htmlContent: string | undefined = undefined;
  status: string | undefined = undefined;
  employeeVo: { uuid?: string; owner?: string; name?: string; pid?: string } | undefined = undefined;
  employeeUuid: string | undefined = undefined;
}

export class EmailAttachmentVO {
  uuid: string | undefined = undefined;
  fileName: string | undefined = undefined;
  fileType: string | undefined = undefined;
  fileSizeKB: number | undefined = undefined;
  contentBase64: string | undefined = undefined;
}

export class EmailDetailVO {
  uuid: string | undefined = undefined;
  messageID: string | undefined = undefined;
  receiveDate: Date | undefined = undefined;
  subject: string | undefined = undefined;
  from: string | undefined = undefined;
  to: string | undefined = undefined;
  cc: string | undefined = undefined;
  plainTextContent: string | undefined = undefined;
  htmlContent: string | undefined = undefined;
  attachments: EmailAttachmentVO[] = [];
}
